import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { ServerApiService } from "app/services/server-api.service";
import { StudentDataService } from "app/services/students/student-data.service";

@Component({
  selector: "app-cancel-course",
  templateUrl: "./cancel-course.component.html",
  styleUrls: ["./cancel-course.component.css"],
})
export class CancelCourseComponent implements OnInit {
  txtReason: string;
  studentId: string;
  constructor(
    private ServerApiService: ServerApiService,
    private location: Location,
    private StudentDataService: StudentDataService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.studentId = this.StudentDataService.getStudentInfo().studentID;
  }

  generateTicket() {
    const ticketDetails = {
      owner: this.studentId,
      customer: this.studentId,
      txtReason: this.txtReason,
      sectionOf: "cancel_course",
    };
    this.ServerApiService.newProblemTicket({ ticketDetails }).subscribe(
      (data: any) => {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = "reload";
        this.router.navigate(["/administration"]);
      }
    );
  }
  goBack() {
    this.location.back();
  }
}
